/* Unika Cream – Landing pelle secca
   Comportamenti condivisi dalle sezioni "unika-*". Il file può essere incluso
   più volte (una per sezione): l'inizializzazione avviene una sola volta. */
(function () {
  if (window.UnikaLanding) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Barriera: confronto pelle secca / con Unika ---------- */
  function initBarrier(root) {
    var buttons = root.querySelectorAll('[data-barrier-state]');
    var userTouched = false;

    function setState(state) {
      root.classList.toggle('is-sealed', state === 'sealed');
      buttons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-barrier-state') === state ? 'true' : 'false');
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        userTouched = true;
        setState(btn.getAttribute('data-barrier-state'));
      });
    });

    // Un solo momento orchestrato: dopo qualche secondo in vista mostra la barriera "sigillata".
    if (!reduceMotion && 'IntersectionObserver' in window && root.hasAttribute('data-autoplay')) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.disconnect();
          setTimeout(function () {
            if (!userTouched) setState('sealed');
          }, 3200);
        });
      }, { threshold: 0.55 });
      io.observe(root.querySelector('.unika-barrier__stage') || root);
    }
  }

  /* ---------- Offerta: scelta del booster nel rituale duo ---------- */
  function selectBooster(offer, index) {
    var chips = offer.querySelectorAll('[data-booster-chip]');
    var chip = null;
    chips.forEach(function (c) {
      var on = c.getAttribute('data-booster-chip') === String(index);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
      c.setAttribute('tabindex', on ? '0' : '-1');
      if (on) chip = c;
    });
    if (!chip) return;

    var data;
    try { data = JSON.parse(chip.getAttribute('data-booster')); } catch (e) { return; }

    offer.querySelectorAll('[data-duo-card]').forEach(function (card) {
      var cardData = data[card.getAttribute('data-duo-card')];
      if (!cardData) return;
      card.querySelectorAll('[data-duo]').forEach(function (el) {
        var key = el.getAttribute('data-duo');
        if (!(key in cardData)) return;
        if (key === 'img') {
          el.src = cardData.img;
          el.alt = cardData.imgAlt || '';
          if (cardData.imgSrcset) el.srcset = cardData.imgSrcset; else el.removeAttribute('srcset');
        } else if (key === 'bullets') {
          el.innerHTML = cardData.bullets;
        } else if (key === 'save' || key === 'compare') {
          el.textContent = cardData[key];
          el.hidden = !cardData[key];
        } else {
          el.textContent = cardData[key];
        }
      });
      var btn = card.querySelector('[data-unika-add]');
      if (btn) {
        btn.setAttribute('data-items', JSON.stringify(cardData.items));
        btn.setAttribute('data-name', cardData.title);
      }
    });
  }

  function initOffer(offer) {
    var chips = Array.prototype.slice.call(offer.querySelectorAll('[data-booster-chip]'));
    chips.forEach(function (chip, i) {
      chip.addEventListener('click', function () {
        selectBooster(offer, chip.getAttribute('data-booster-chip'));
      });
      chip.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = chips[(i + 1) % chips.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = chips[(i - 1 + chips.length) % chips.length];
        if (next) {
          e.preventDefault();
          next.focus();
          next.click();
        }
      });
    });
  }

  // Link "Scegli il rituale con…" nelle altre sezioni: preseleziona il booster e scorre all'offerta.
  function initPickLinks() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-unika-pick]');
      if (!link) return;
      var offer = document.querySelector('[data-unika-offer]');
      if (!offer) return;
      e.preventDefault();
      selectBooster(offer, link.getAttribute('data-unika-pick'));
      offer.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------- Aggiunta al carrello (singolo prodotto o rituale) ---------- */
  function cartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    return drawer && typeof drawer.renderContents === 'function' ? drawer : null;
  }

  function sectionsToRender(drawer) {
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return [];
    return drawer.getSectionsToRender().map(function (s) { return s.id; });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function applyDiscount(code, sections) {
    // Mantiene eventuali codici già presenti nel carrello e aggiunge quello del rituale.
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
        if (codes.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) === -1) codes.push(code);
        var body = { discount: codes.join(',') };
        if (sections.length) {
          body.sections = sections.join(',');
          body.sections_url = window.location.pathname;
        }
        return postJSON((window.routes && window.routes.cart_update_url) || '/cart/update.js', body);
      });
  }

  function setMsg(btn, text, type) {
    var holder = btn.closest('[data-unika-buy]');
    var msg = holder ? holder.querySelector('[data-unika-msg]') : null;
    if (!msg) return;
    msg.textContent = text || '';
    msg.classList.toggle('is-error', type === 'error');
    msg.classList.toggle('is-success', type === 'success');
  }

  function addToCart(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var items;
    try { items = JSON.parse(btn.getAttribute('data-items') || '[]'); } catch (e) { items = []; }
    if (!items.length) return;

    var code = (btn.getAttribute('data-discount') || '').trim();
    var drawer = cartDrawer();
    var sections = sectionsToRender(drawer);
    var label = btn.querySelector('[data-label]') || btn;
    var original = label.textContent;

    btn.setAttribute('aria-busy', 'true');
    label.textContent = btn.getAttribute('data-loading') || 'Aggiunta in corso…';
    setMsg(btn, '');

    var body = { items: items };
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    postJSON((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', body)
      .then(function (res) {
        if (res && res.status) throw res;
        if (!code) return res;
        // Se il codice non si applica, i prodotti restano comunque nel carrello.
        return applyDiscount(code, sections)
          .then(function (updated) { return updated && !updated.status && updated.sections ? updated : res; })
          .catch(function () { return res; });
      })
      .then(function (res) {
        if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'unika-landing', cartData: res });
        }
        if (drawer && res && res.sections) {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(res);
          setMsg(btn, btn.getAttribute('data-success') || 'Aggiunto al carrello.', 'success');
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) {
        var detail = err && (err.description || err.message);
        setMsg(btn, 'Non è stato possibile aggiungere al carrello' + (detail ? ': ' + detail : '. Riprova tra qualche istante.'), 'error');
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        label.textContent = original;
      });
  }

  function initAddButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-unika-add]');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn);
    });
  }

  /* ---------- Barra sticky ---------- */
  function initSticky(bar) {
    if (!('IntersectionObserver' in window)) return;
    var hero = document.querySelector('[data-unika-hero]');
    var offer = document.querySelector('[data-unika-offer]');
    var heroVisible = true;
    var offerVisible = false;

    function update() {
      bar.classList.toggle('is-visible', !heroVisible && !offerVisible);
      bar.setAttribute('aria-hidden', !heroVisible && !offerVisible ? 'false' : 'true');
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === hero) heroVisible = entry.isIntersecting;
        if (entry.target === offer) offerVisible = entry.isIntersecting;
      });
      update();
    }, { threshold: 0 });

    if (hero) io.observe(hero); else heroVisible = false;
    if (offer) io.observe(offer);
    update();
  }

  function init() {
    document.querySelectorAll('[data-unika-barrier]').forEach(initBarrier);
    document.querySelectorAll('[data-unika-offer]').forEach(initOffer);
    document.querySelectorAll('[data-unika-sticky]').forEach(initSticky);
    initPickLinks();
    initAddButtons();
  }

  window.UnikaLanding = { selectBooster: selectBooster };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: reinizializza la sezione ricaricata.
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    t.querySelectorAll('[data-unika-barrier]').forEach(initBarrier);
    t.querySelectorAll('[data-unika-offer]').forEach(initOffer);
    t.querySelectorAll('[data-unika-sticky]').forEach(initSticky);
  });
})();
